import { AuthLayout } from '@/components/layouts/AuthLayout'
import { AuthForm } from '@/components/molecules/AuthForm'
import { useLoginForm } from '@/hooks/forms/useLoginForm'
import { useAppSelector } from '@/store/hooks'
import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

const Auth = () => {
  const loginForm = useLoginForm()
  const navigate = useNavigate()
  const { user } = useAppSelector(state => state.auth)

  useEffect(() => {
    if (user) {
      navigate('/cars')
    }
  }, [user, navigate])

  return (
    <AuthLayout>
      <AuthForm form={loginForm.form} onSubmit={loginForm.onSubmit} />
    </AuthLayout>
  )
}

export default Auth
